import React, { useState } from 'react';
import { Container } from './ui/Container';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: 'What is SnoreStop™?',
  a: 'A comfortable mouthpiece that gently positions your jaw to open airways and reduce snoring naturally.'
}, {
  q: 'When will I see results?',
  a: 'Most users notice quieter sleep from the first night, with significant reduction within 1-3 nights.'
}, {
  q: 'How do I use it?',
  a: 'Mold it to your teeth in 60 seconds using warm water, then wear it while you sleep. Simple as that.'
}, {
  q: 'Is it safe and comfortable?',
  a: 'Yes. Made from medical-grade, BPA-free silicone. Moldable for a custom fit. Thousands use it nightly.'
}, {
  q: "What if it doesn't work for me?",
  a: "60-day money-back guarantee. If you're not sleeping better, we'll refund you. Zero risk."
}, {
  q: 'Will it fit me?',
  a: 'Yes. The moldable design creates a custom fit for any mouth size.'
}, {
  q: 'Can I breathe through it?',
  a: 'Absolutely. The design allows natural breathing while positioning your jaw.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 bg-white" data-id="element-114">
      <Container className="max-w-3xl" data-id="element-115">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-116">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-117">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-118">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-119">
                <span className="font-semibold text-gray-900" data-id="element-120">{faq.q}</span>
                {openIndex === index ? <Minus className="w-5 h-5 text-blue-600" data-id="element-121" /> : <Plus className="w-5 h-5 text-gray-400" data-id="element-122" />}
              </button>

              <AnimatePresence data-id="element-123">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-124">
                    <div className="p-4 pt-0 text-gray-600 bg-white border-t border-gray-100" data-id="element-125">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </Container>
    </section>;
}